<div class="container" class="bgcol">
  <mat-card-header>
    <mat-toolbar class="toolbar">
      <mat-card-title>{{ "ajouteReservation" | translate }}</mat-card-title>
      <span class="toolbar-spacer"></span>
      <mat-icon (click)="close()">cancel</mat-icon>
    </mat-toolbar>
  </mat-card-header>
    <form [formGroup]="passagerForm" fxLayout="column" style="margin-bottom:-1em !important; display: inline-block !important">
    <ng-container>

    </ng-container>
      <mat-card-content class="padding">



        <div fxLayout="row" fxLayout-sm="column" fxLayout-xs="column" fxLayout-gt-xs="column"
            fxLayout-gt-sm="row" fxLayoutGap="10px" >

            <mat-form-field appearance="outline" fxFlex="27">
              <mat-label>{{'table_headers.category' | translate}}</mat-label>
              <mat-select  type="double" matInput (selectionChange)="filterVoyagecat($event)"
              formControlName="category" tabindex="1]" >

                    <mat-option>
                    </mat-option>
                    <mat-option [value]="item" *ngFor="let item of datelist">
                    </mat-option>

                  </mat-select>
              <button type="button" mat-icon-button matSuffix
                  [disabled]="(loading$ | async) || !passagerForm.valid">
                  <mat-icon color="primary">category</mat-icon>
              </button>


          </mat-form-field>


          <mat-form-field appearance="outline" fxFlex="27">
            <mat-label>{{'form_fields.typeVoyage' | translate}}</mat-label>
            <mat-select disabled formControlName="idtypevoyage" tabindex="2">
              <mat-option [value]="item.idtype" *ngFor="let item of typevoyagelist">
                {{item.nomtype}}
              </mat-option>
            </mat-select>
            <button type="button" mat-icon-button matSuffix
              [disabled]="(loading$ | async) || !passagerForm.valid">
              <mat-icon color="primary">airport_shuttle</mat-icon>
            </button>
          </mat-form-field>


        <mat-form-field appearance="outline" fxFlex="25">
          <mat-label>{{'form_fields.tarif' | translate}}</mat-label>
          <input class="notAllowedCursor"
          type="double" matInput
              placeholder="{{'form_fields.tarif' | translate}}"
              formControlName="tarif" tabindex="3" readonly="readonly">
          <button type="button" mat-icon-button matSuffix
              [disabled]="(loading$ | async) || !passagerForm.valid">
              <mat-icon color="primary">attach_money</mat-icon>
          </button>

          <div *ngIf="tarif.invalid && (tarif.dirty || tarif.touched)" class="alert-danger">
              <div *ngIf="tarif.errors.required">
                  montant du ticket obligatoire
              </div>
          </div>

      </mat-form-field>
        </div>



        <div fxLayout="row" fxLayout-sm="column" fxLayout-xs="column" fxLayout-gt-xs="column" fxLayout-gt-sm="row" fxLayoutGap="10px">

          <mat-form-field appearance="outline" fxFlex="27">
            <mat-label>{{'form_fields.date' | translate}}</mat-label>
            <mat-select tabindex="4" >
              <mat-option>
                {{'form_fields.date' | translate}}
              </mat-option>
              <mat-option [value]="item" *ngFor="let item of datelist">
                {{item | date:"dd-MM-yyyy"}}
              </mat-option>

            </mat-select>
            <button type="button" mat-icon-button matSuffix>
            <mat-icon color="primary">access_time</mat-icon>
          </button>
          </mat-form-field>

                      <mat-form-field appearance="outline" fxFlex="30">
                      <mat-label>{{'form_fields.voyage' | translate}}</mat-label>
                      <mat-select  formControlName="idvoyage" tabindex="5" (selectionChange)="getTripDestination($event)">
                        <mat-option [value]="item.idvoyage" *ngFor="let item of voyageList" (click)="tripdestination(item)">
                          {{item.nomvoyage}}
                        </mat-option>
                      </mat-select>
                      <button type="button" mat-icon-button matSuffix
                        [disabled]="(loading$ | async) || !passagerForm.valid">
                        <mat-icon color="primary">departure_board</mat-icon>
                      </button>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="25">
                      <mat-label>{{
                        "form_fields.destination" | translate
                      }}</mat-label>
                      <mat-select formControlName="iddestination" id="destination"
                      (selectionChange)="filtertarifydestiantionandstatus($event)" tabindex="6">
                        <mat-option [value]="item.iddestinantion" *ngFor="let item of destinations">
                          {{ item.nomdest }}
                        </mat-option>
                      </mat-select>
                      <button
                        type="button"
                        mat-icon-button
                        matSuffix
                        [disabled]="(loading$ | async) || !passagerForm.valid"
                      >
                        <mat-icon color="primary">home</mat-icon>
                      </button>
                    </mat-form-field>


              </div>

              <ng-container>
                <div fxLayout-sm="column" fxLayout="row" fxLayout-xs="column" fxLayout-gt-xs="column" fxLayout-gt-sm="row" fxLayoutGap="10px">

                  <mat-form-field appearance="outline" fxFlex="27">
                    <mat-label>{{'form_fields.phone_number' | translate}}</mat-label>
                    <input type="text" (keyup)="numbersonly($event)" matInput
                        placeholder="{{'form_fields.phone_number' | translate}}" #searchprimarynumber
                        formControlName="contact" tabindex="7" maxlength="9" [matAutocomplete]="auto">
                        <mat-autocomplete  #auto="matAutocomplete">
                          <ng-container *ngFor="let item of customerphone">
                            <ng-container *ngFor="let item2 of item.customerDTO">
                              <mat-option [value]="item2.name" (click)="fillnumber(item,item2.name)">
                                {{item2.name}}/ {{item.contact}}
                              </mat-option>
                            </ng-container>
                          </ng-container>
                        </mat-autocomplete>
                    <button type="button" mat-icon-button matSuffix
                        [disabled]="(loading$ | async) || !passagerForm.valid">
                        <mat-icon color="primary">phone</mat-icon>
                    </button>

                    <div *ngIf="contact.invalid && (contact.dirty || contact.touched)"
                    class="alert-danger" style="margin-left: 120px !important;">
                        <div *ngIf="contact.errors.required">
                            Phone number is mandatory
                        </div>
                        <div *ngIf="contact.errors?.minlength">
                            Phone number is 9 digit min
                        </div>
                    </div>

                </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="30">
                    <mat-label>{{'form_fields.name' | translate}}</mat-label>
                    <input type="text" formControlName="nomclient" placeholder="{{'form_fields.name' | translate}}"
                    tabindex="8" #searchprimaryname matInput [matAutocomplete]="auto2">
                    <mat-autocomplete  #auto2="matAutocomplete">
                      <ng-container *ngFor="let item of customername">
                        <ng-container *ngFor="let item2 of item.phoneDTO">
                          <mat-option [value]="item.name" (click)="fillnameNumber(item,item2.contact)">
                            {{item.name}}/ {{item2.contact}}
                          </mat-option>
                        </ng-container>
                      </ng-container>
                    </mat-autocomplete>

                    <button type="button" mat-icon-button matSuffix
                      [disabled]="(loading$ | async) || !passagerForm.valid">
                      <mat-icon color="primary">person</mat-icon>
                    </button>
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="25">
                    <mat-label>{{'form_fields.idcardnumber' | translate}}</mat-label>
                    <input type="text" (keyup)="numbersonly($event)" matInput
                        placeholder="{{'form_fields.idcardnumber' | translate}}"
                        formControlName="cni" tabindex="9">
                    <button type="button" mat-icon-button matSuffix
                        [disabled]="(loading$ | async) || !passagerForm.valid">
                        <mat-icon color="primary">featured_play_list</mat-icon>
                    </button>

                    <div *ngIf="cni.invalid && (cni.dirty || cni.touched)" class="alert-danger">
                        <div *ngIf="cni.errors.required">
                            ID card number is mandatory
                        </div>
                        <div *ngIf="cni.errors?.minlength">
                            ID card number is 4 digit min
                        </div>
                    </div>
                  </mat-form-field>
                </div>

              </ng-container>

                <div fxLayout="row" fxLayoutGap="10px">

                  <mat-form-field appearance="outline" fxFlex="35">
                    <mat-label>{{'form_fields.nombredeplace' | translate}}</mat-label>
                    <mat-select type="double" matInput
                    placeholder="{{'form_fields.nombredeplace' | translate}}"
                    (keyup)="numbersonly($event)" formControlName="place" tabindex="10">
                      <mat-option>
                        <ngx-mat-select-search placeholderLabel="Rechercher" [formControl]=""
                        noEntriesFoundLabel="'no matching bank found'"></ngx-mat-select-search>
                      </mat-option>
                    </mat-select>
                    <button type="button" mat-icon-button matSuffix
                        >
                        <mat-icon color="primary">airline_seat_recline_normal</mat-icon>
                    </button>

                    <div class="alert-danger">
                        <div >
                            Numero de place obligatoire
                        </div>
                    </div>

                </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="30">
                      <mat-label>{{'montant' | translate}}</mat-label>
                      <input readonly="readonly" type="text" matInput
                          placeholder="{{'montant' | translate}}" (keyup)="numbersonly2($event)"
                           tabindex="11" class="notAllowedCursor">
                      <button type="button" mat-icon-button matSuffix
                      [disabled]="(loading$ | async) || !passagerForm.valid">
                          <mat-icon color="primary">currency_exchange</mat-icon>
                      </button>


                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex="25">
                    <mat-label>{{'form_fields.amount_to_refund' | translate}}</mat-label>
                    <input class="notAllowedCursor" type="double" matInput
                        placeholder="{{'form_fields.amount_to_refund' | translate}}" (keyup)="numbersonly3($event)"
                        formControlName="reste" tabindex="12" readonly="readonly">
                    <button type="button" mat-icon-button matSuffix
                        [disabled]="(loading$ | async) || !passagerForm.valid">
                        <mat-icon color="primary">money_off</mat-icon>
                    </button>

                </mat-form-field>

          </div>
          <div fxLayout="row-reverse" fxLayoutGap="10px">

            <button mat-raised-button cdkFocusInitial color="primary" tabindex="12"
                disabled tabindex="13"><span *ngIf="!(loading$ | async)">{{'buttons.save' |
                    translate}}</span>
                <mat-spinner color="accent" class="mat-spinner-white mx-auto" *ngIf="loading$ | async" [diameter]="33">
                </mat-spinner>
            </button>

            <a  class="cancelbtn"  tabindex="13" (click)="close()" mat-raised-button> {{'buttons.cancel' | translate}}</a>
        </div>

      </mat-card-content>


  </form>


</div>
